//
// HudController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";

var HudController = createModule("BIRD::HudController", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        isOnlyFiltered: [2],
        getFilterArray: [[7]],
        getOnlyFilterArray: [[7]],
        isFiltered: [2],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default HudController;
